import { Text } from '@atlaskit/primitives';
import { FormattedMessage } from 'react-intl-next';

import { ListToggle } from '../../../components/list-toggle';
import { useToggleCodeReviewerSetting } from '../../hooks/use-toggle-code-reviewer-setting';

type CodeReviewerSettingListToggleProps = {
	entity: GH.Organisation | GH.Repository;
	disableToggle: boolean;
	onToggle?: (newValue: boolean) => void;
};
export const CodeReviewerSettingListToggle = ({
	entity,
	disableToggle,
	onToggle,
}: CodeReviewerSettingListToggleProps) => {
	const { isEnabled, updateSetting, error } = useToggleCodeReviewerSetting({ entity, onToggle });

	const actionSubjectId = 'repoId' in entity ? 'repository-toggle' : 'organisation-toggle';
	const toggleType = 'repoId' in entity ? 'repository' : 'organisation';
	const source =
		'repoId' in entity
			? 'code-reviewer-repository-settings'
			: 'code-reviewer-organisation-settings';

	if (error) {
		return (
			<Text>
				<FormattedMessage {...error} />
			</Text>
		);
	}

	return (
		<ListToggle
			onChange={() => updateSetting(!isEnabled)}
			isChecked={isEnabled}
			analyticsEvent={{
				action: 'clicked',
				actionSubject: 'code-reviewer-setting-toggle',
				actionSubjectId,
				source,
			}}
			isDisabled={disableToggle}
			toggleType={toggleType}
		/>
	);
};
